/* eslint-disable @typescript-eslint/no-explicit-any */
import { jwtDecode } from 'jwt-decode'
import { AuthenticationService } from './AuthenticationService'

export default class JwtCookie {
  public static isValid = async (): Promise<boolean> => {
    const cookieName = 'jwt_hp'
    const cookieValue = JwtCookie.getCookieValue(cookieName)
    if (cookieValue === undefined) {
      return await this.checkRefreshToken()
    }
    return !JwtCookie.isExpired(jwtDecode(cookieValue))
  }

  public static setTokenInCookie(token: string): void {
    const decoded: any = jwtDecode(token)
    const expirationDate = new Date(decoded.exp * 1000).toUTCString()
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:'
    const securePart = secure ? '; secure' : ''
    document.cookie = `jwt_hp=${token}; expires=${expirationDate}; path=/; samesite=strict${securePart}`
  }

  public static getToken(): string | null {
    return this.getCookieValue('jwt_hp') || null
  }

  public static getCookieValue = (name: string): string | undefined => {
    return JwtCookie._allCookie()
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1]
  }

  public static getJwtExpirationDate = (cookieValue: string): string => {
    let exp = new Date().toUTCString()
    const decodedValue: any = jwtDecode(cookieValue)
    const expirationTime: number = decodedValue.exp
    if (expirationTime) {
      exp = new Date(expirationTime * 1000).toUTCString()
    }
    return exp
  }

  public static isExpired = (cookieValue: any): boolean => {
    if (!Object.prototype.hasOwnProperty.call(cookieValue, 'exp')) {
      return false
    }

    const expirationInSeconds = Number(cookieValue.exp)
    if (!Number.isFinite(expirationInSeconds)) {
      return false
    }

    return Date.now() >= expirationInSeconds * 1000
  }

  public static getTokenExpirationTimestampMs = (token: string | null): number | null => {
    if (!token) {
      return null
    }

    try {
      const decoded: any = jwtDecode(token)
      const expirationInSeconds = Number(decoded?.exp)

      if (!Number.isFinite(expirationInSeconds)) {
        return null
      }

      return expirationInSeconds * 1000
    } catch {
      return null
    }
  }

  public static clearCookies(): void {
    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
    })
  }

  private static _allCookie = () => {
    return document.cookie.split('; ')
  }

  private static async checkRefreshToken() {
    const refreshToken = JwtCookie.getCookieValue('refresh_token')
    if (refreshToken) {
      await AuthenticationService.refreshAuthToken()
      return true
    }
    return false
  }

  public static deleteRefreshToken(): void {
    document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
  }
}
